import { render } from "./FormCreateVideo.vue?vue&type=template&id=e97511fc&scoped=true"
import script from "./FormCreateVideo.vue?vue&type=script&lang=js"
export * from "./FormCreateVideo.vue?vue&type=script&lang=js"

import "./FormCreateVideo.vue?vue&type=style&index=0&id=e97511fc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e97511fc"]])

export default __exports__